import { Tooltip } from '@mui/material';

export const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00065 0.332031C3.31398 0.332031 0.333984 3.31203 0.333984 6.9987C0.333984 10.6854 3.31398 13.6654 7.00065 13.6654C10.6873 13.6654 13.6673 10.6854 13.6673 6.9987C13.6673 3.31203 10.6873 0.332031 7.00065 0.332031ZM10.334 9.39203L9.39398 10.332L7.00065 7.9387L4.60732 10.332L3.66732 9.39203L6.06065 6.9987L3.66732 4.60536L4.60732 3.66536L7.00065 6.0587L9.39398 3.66536L10.334 4.60536L7.94065 6.9987L10.334 9.39203Z"
        fill="#D2D6DB"
      />
    </svg>
  );
};

export const ClockTickIcon = ({ color = '#757B87' }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.68433C8.92541 3.68433 8.85387 3.71398 8.80113 3.76671C8.7484 3.81944 8.71875 3.89099 8.71875 3.96558V9.02808L12.2063 11.1543C12.2503 11.1812 12.301 11.1948 12.3525 11.1937C12.4506 11.1922 12.5415 11.1414 12.5944 11.0587C12.6335 10.9947 12.6455 10.9176 12.6275 10.8447C12.6096 10.7718 12.5632 10.7091 12.4988 10.6706L9.28125 8.71308V3.96558C9.28125 3.89099 9.2516 3.81945 9.19887 3.76671C9.14613 3.71398 9.07459 3.68433 9 3.68433Z"
        fill={color}
      />
      <path
        d="M9.00004 1.27686C7.48534 1.27686 6.00529 1.72984 4.74994 2.57758C3.49468 3.42538 2.52169 4.62913 1.95589 6.03418C1.3901 7.43926 1.25746 8.98138 1.57496 10.4625C1.58973 10.5353 1.63332 10.5991 1.69584 10.6393C1.7583 10.6796 1.83442 10.6929 1.90683 10.6762C1.97996 10.6613 2.04412 10.618 2.08526 10.5558C2.12645 10.4935 2.14116 10.4175 2.12621 10.3444C2.02016 9.8603 1.9673 9.36613 1.96871 8.8706C1.96871 7.0058 2.70952 5.21735 4.02806 3.8987C5.34671 2.58011 7.13517 1.83935 8.99997 1.83935C10.8648 1.83935 12.6532 2.58016 13.9719 3.8987C15.2905 5.21735 16.0312 7.0058 16.0312 8.8706C16.0312 10.7354 15.2904 12.5239 13.9719 13.8425C12.6532 15.1611 10.8648 15.9019 8.99997 15.9019C8.92537 15.9019 8.85383 15.9315 8.8011 15.9842C8.74836 16.037 8.71871 16.1085 8.71871 16.1831C8.71871 16.2577 8.74836 16.3292 8.8011 16.382C8.85383 16.4347 8.92537 16.4644 8.99997 16.4644C11.014 16.4644 12.9454 15.6643 14.3695 14.2402C15.7936 12.816 16.5937 10.8845 16.5937 8.87061C16.5937 6.85671 15.7937 4.92516 14.3695 3.50106C12.9454 2.07696 11.0139 1.27686 8.99997 1.27686L9.00004 1.27686Z"
        fill={color}
      />
      <path
        d="M7.7235 12.1901L3.42603 16.1881L1.26971 14.0168C1.13167 13.876 0.942768 13.7966 0.745605 13.7966C0.548441 13.7966 0.359543 13.876 0.221498 14.0168C0.0797083 14.1574 0 14.3488 0 14.5484C0 14.748 0.0797083 14.9395 0.221498 15.08L2.87198 17.7754C3.01486 17.9187 3.20875 17.9995 3.41106 18C3.59777 17.9881 3.77356 17.9083 3.90522 17.7754L8.74177 13.283C8.88262 13.145 8.96202 12.9561 8.96202 12.7589C8.96202 12.5618 8.88262 12.3729 8.74177 12.2348C8.61292 12.0934 8.43307 12.0091 8.24198 12.0007C8.0509 11.9923 7.86419 12.0605 7.7235 12.1901Z"
        fill={color}
      />
    </svg>
  );
};

export const ClockIcon = ({ color = '#757B87' }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.40625C6.98595 1.40625 5.05455 2.20629 3.63045 3.63045C2.20635 5.05461 1.40625 6.9861 1.40625 9C1.40625 11.0139 2.20629 12.9454 3.63045 14.3695C5.05461 15.7936 6.9861 16.5938 9 16.5938C11.0139 16.5938 12.9454 15.7937 14.3695 14.3695C15.7936 12.9454 16.5938 11.0139 16.5938 9C16.5908 6.987 15.7898 5.0571 14.3663 3.63375C12.9428 2.21028 11.013 1.40925 9 1.40625ZM9 16.0312C7.1352 16.0312 5.34675 15.2904 4.0281 13.9719C2.70951 12.6532 1.96875 10.8648 1.96875 9C1.96875 7.1352 2.70956 5.34675 4.0281 4.0281C5.34675 2.70951 7.1352 1.96875 9 1.96875C10.8648 1.96875 12.6532 2.70956 13.9719 4.0281C15.2905 5.34675 16.0312 7.1352 16.0312 9C16.0283 10.8639 15.2865 12.6505 13.9686 13.9686C12.6506 15.2865 10.8639 16.0282 9 16.0312Z"
        fill={color}
      />
      <path
        d="M12.4988 10.8057L9.28125 8.84245V4.09495C9.28125 3.99446 9.22764 3.90165 9.14063 3.85138C9.05361 3.80117 8.94639 3.80117 8.85938 3.85138C8.77236 3.90166 8.71875 3.99447 8.71875 4.09495V9.15745L12.2063 11.2837C12.2503 11.3105 12.301 11.3242 12.3525 11.3231C12.4332 11.3213 12.5094 11.2848 12.5614 11.2231C12.6134 11.1612 12.6364 11.08 12.6244 11.0002C12.6124 10.9203 12.5667 10.8494 12.4988 10.8056L12.4988 10.8057Z"
        fill={color}
      />
    </svg>
  );
};

export const PencilIcon = ({ forSingleCard = false }: { forSingleCard?: boolean }) => {
  return (
    <Tooltip title="Edit task minutes">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={forSingleCard ? '17' : '12'}
        height={forSingleCard ? '17' : '12'}
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_23997_183710)">
          <path
            d="M13.5 1.5L16.5 4.5M1.5 16.5L2.4573 12.9899C2.51976 12.7609 2.55098 12.6464 2.59892 12.5396C2.64149 12.4448 2.69379 12.3547 2.75499 12.2707C2.82391 12.1761 2.90783 12.0922 3.07568 11.9243L10.8257 4.17426C10.9742 4.02576 11.0485 3.9515 11.1341 3.92368C11.2094 3.89921 11.2906 3.89921 11.3659 3.92368C11.4515 3.9515 11.5258 4.02576 11.6743 4.17426L13.8257 6.32574C13.9742 6.47424 14.0485 6.5485 14.0763 6.63412C14.1008 6.70943 14.1008 6.79057 14.0763 6.86588C14.0485 6.9515 13.9742 7.02576 13.8257 7.17426L6.07568 14.9243C5.90783 15.0922 5.82391 15.1761 5.72931 15.245C5.64532 15.3062 5.55519 15.3585 5.46039 15.4011C5.35361 15.449 5.23911 15.4802 5.0101 15.5427L1.5 16.5Z"
            stroke="#6C737F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_23997_183710">
            <rect
              width="18"
              height="18"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </Tooltip>
  );
};

export const transformedTaskTypeArray = (taskType: any) => {
  return taskType?.map((item: any) => {
    let icon;
    switch (item.key) {
      case 'EVALUATION':
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M3.125 2.5V11.875C3.125 12.3723 3.32254 12.8492 3.67417 13.2008C4.02581 13.5525 4.50272 13.75 5 13.75H6.875M3.125 2.5H1.875M3.125 2.5H16.875M6.875 13.75H13.125M6.875 13.75L6.04167 16.25M16.875 2.5H18.125M16.875 2.5V11.875C16.875 12.3723 16.6775 12.8492 16.3258 13.2008C15.9742 13.5525 15.4973 13.75 15 13.75H13.125M13.125 13.75L13.9583 16.25M6.04167 16.25H13.9583M6.04167 16.25L5.625 17.5M13.9583 16.25L14.375 17.5M6.25 10L8.75 7.5L10.54 9.29C11.381 8.08275 12.4768 7.07485 13.75 6.3375"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
        break;
      case 'THERAPY':
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M13.055 3.24C12.9439 2.84692 12.7075 2.50087 12.3816 2.25449C12.0558 2.0081 11.6585 1.87485 11.25 1.875H8.75C7.89167 1.875 7.16667 2.4525 6.945 3.24M13.055 3.24C13.1008 3.40167 13.125 3.57333 13.125 3.75C13.125 3.91576 13.0592 4.07473 12.9419 4.19194C12.8247 4.30915 12.6658 4.375 12.5 4.375H7.5C7.33424 4.375 7.17527 4.30915 7.05806 4.19194C6.94085 4.07473 6.875 3.91576 6.875 3.75C6.875 3.57333 6.9 3.40167 6.945 3.24M13.055 3.24C13.5933 3.28083 14.1283 3.33167 14.6608 3.39333C15.5775 3.5 16.25 4.29083 16.25 5.21417V16.25C16.25 16.7473 16.0525 17.2242 15.7008 17.5758C15.3492 17.9275 14.8723 18.125 14.375 18.125H5.625C5.12772 18.125 4.65081 17.9275 4.29917 17.5758C3.94754 17.2242 3.75 16.7473 3.75 16.25V5.21417C3.75 4.29083 4.42167 3.5 5.33917 3.39333C5.87336 3.33148 6.40875 3.28036 6.945 3.24"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.08337 11.2526H12.9167M10 8.33594V14.1693"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
        break;
      case 'GROUP_THERAPY':
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M14.481 12.837C14.8708 12.5708 15.0628 12.5176 15.5346 12.5004C16.0063 12.4832 16.4733 12.5999 16.8815 12.837C17.2896 13.0741 17.6223 13.422 17.8411 13.8403C18.0598 14.2586 18.1556 14.7303 18.1174 15.2008C17.1176 15.5503 16.0556 15.6863 14.9999 15.6C14.9967 14.6555 14.8081 13.2974 14.2991 12.5018C13.8474 11.7933 13.1409 11.0184 12.404 10.6146C11.6671 10.2108 10.8402 9.99943 9.99995 10C9.15981 9.99957 8.33314 10.211 7.59639 10.6148C6.85964 11.0186 6.15244 11.7934 5.70077 12.5018M14.9991 15.5992L14.9999 15.625C14.9999 15.8125 14.9899 15.9975 14.9691 16.18C13.4569 17.0476 11.7434 17.5028 9.99995 17.5C8.19161 17.5 6.49411 17.02 5.03078 16.18C5.00936 15.9871 4.99906 15.7932 4.99995 15.5992M4.99995 15.5992C3.94464 15.6886 2.8832 15.5531 1.88411 15.2017C1.84607 14.7313 1.94194 14.2598 2.16064 13.8416C2.37933 13.4234 2.71192 13.0757 3.11995 12.8386C3.52798 12.6015 3.99478 12.4847 4.46638 12.5018C4.93798 12.5188 5.41642 12.837 5.70077 12.5018M4.99995 15.5992C5.00294 14.6548 5.19213 13.2975 5.70077 12.5018M12.4999 5.625C12.4999 6.28804 12.2366 6.92393 11.7677 7.39277C11.2989 7.86161 10.663 8.125 9.99995 8.125C9.33691 8.125 8.70102 7.86161 8.23218 7.39277C7.76334 6.92393 7.49995 6.28804 7.49995 5.625C7.49995 4.96196 7.76334 4.32607 8.23218 3.85723C8.70102 3.38839 9.33691 3.125 9.99995 3.125C10.663 3.125 11.2989 3.38839 11.7677 3.85723C12.2366 4.32607 12.4999 4.96196 12.4999 5.625ZM17.4999 8.125C17.4999 8.37123 17.4514 8.61505 17.3572 8.84253C17.263 9.07002 17.1249 9.27672 16.9508 9.45082C16.7767 9.62493 16.57 9.76305 16.3425 9.85727C16.115 9.9515 15.8712 10 15.6249 10C15.3787 10 15.1349 9.9515 14.9074 9.85727C14.6799 9.76305 14.4732 9.62493 14.2991 9.45082C14.125 9.27672 13.9869 9.07002 13.8927 8.84253C13.7984 8.61505 13.7499 8.37123 13.7499 8.125C13.7499 7.62772 13.9475 7.15081 14.2991 6.79917C14.6508 6.44754 15.1277 6.25 15.6249 6.25C16.1222 6.25 16.5991 6.44754 16.9508 6.79917C17.3024 7.15081 17.4999 7.62772 17.4999 8.125ZM6.24995 8.125C6.24995 8.37123 6.20145 8.61505 6.10722 8.84253C6.01299 9.07002 5.87488 9.27672 5.70077 9.45082C5.52666 9.62493 5.31996 9.76305 5.09248 9.85727C4.86499 9.9515 4.62118 10 4.37495 10C4.12872 10 3.8849 9.9515 3.65742 9.85727C3.42993 9.76305 3.22323 9.62493 3.04912 9.45082C2.87501 9.27672 2.7369 9.07002 2.64267 8.84253C2.54845 8.61505 2.49995 8.37123 2.49995 8.125C2.49995 7.62772 2.69749 7.15081 3.04912 6.79917C3.40075 6.44754 3.87767 6.25 4.37495 6.25C4.87223 6.25 5.34914 6.44754 5.70077 6.79917C6.0524 7.15081 6.24995 7.62772 6.24995 8.125Z"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 13.3307H12M10 11.6641V14.9974"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
        break;
      case 'INSURANCE_CALL':
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M1.875 5.625C1.875 12.5283 7.47167 18.125 14.375 18.125H16.25C16.7473 18.125 17.2242 17.9275 17.5758 17.5758C17.9275 17.2242 18.125 16.7473 18.125 16.25V15.1067C18.125 14.6767 17.8325 14.3017 17.415 14.1975L13.7292 13.2758C13.3625 13.1842 12.9775 13.3217 12.7517 13.6233L11.9433 14.7008C11.7083 15.0142 11.3025 15.1525 10.935 15.0175C9.57073 14.5159 8.33179 13.7238 7.30398 12.696C6.27618 11.6682 5.48406 10.4293 4.9825 9.065C4.8475 8.6975 4.98583 8.29167 5.29917 8.05667L6.37667 7.24833C6.67917 7.0225 6.81583 6.63667 6.72417 6.27083L5.8025 2.585C5.75178 2.38225 5.63477 2.20225 5.47004 2.07361C5.30532 1.94498 5.10234 1.87507 4.89333 1.875H3.75C3.25272 1.875 2.77581 2.07254 2.42417 2.42417C2.07254 2.77581 1.875 3.25272 1.875 3.75V5.625Z"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
        break;
      case 'SCREENINGS':
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.16671 6.06221H13.3334M9.16671 9.58073H13.3334M9.16671 13.0992H13.3334M8.33337 1.66406H4.58337C3.89337 1.66406 3.33337 2.25517 3.33337 2.98351V16.178C3.33337 16.9063 3.89337 17.4974 4.58337 17.4974H15.4167C16.1067 17.4974 16.6667 16.9063 16.6667 16.178V2.98351C16.6667 2.25517 16.1067 1.66406 15.4167 1.66406H8.33337ZM6.66671 6.06221H6.6756V6.07159H6.66671V6.06221ZM6.66671 9.58073H6.6756V9.59011H6.66671V9.58073ZM6.66671 13.0992H6.6756V13.1086H6.66671V13.0992Z"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
        break;
      default:
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
          >
            <path
              d="M10.4811 10.712C10.8709 10.4458 11.0629 10.3926 11.5347 10.3754C12.0064 10.3582 12.4734 10.4749 12.8816 10.712C13.2897 10.9491 13.6224 11.297 13.8412 11.7153C14.0599 12.1336 14.1557 12.6053 14.1176 13.0758C13.1177 13.4253 12.0557 13.5613 11.0001 13.475C10.9968 12.5305 10.8082 11.1724 10.2992 10.3768C9.84748 9.66826 9.14098 8.89336 8.40408 8.48959C7.66717 8.08581 6.84033 7.87443 6.00005 7.875C5.15992 7.87457 4.33324 8.08602 3.59649 8.48979C2.85975 8.89356 2.15255 9.66838 1.70088 10.3768C1.19223 11.1725 1.00305 12.5298 1.00005 13.4742C0.999166 13.6682 1.00946 13.8621 1.03089 14.055C2.49422 14.895 4.19172 15.375 6.00005 15.375C7.74346 15.3778 9.45702 14.9226 10.9692 14.055C10.9901 13.8725 11.0001 13.6875 11.0001 13.5L10.9992 13.4742M8.50005 3.5C8.50005 4.16304 8.23666 4.79893 7.76782 5.26777C7.29898 5.73661 6.66309 6 6.00005 6C5.33701 6 4.70113 5.73661 4.23229 5.26777C3.76344 4.79893 3.50005 4.16304 3.50005 3.5C3.50005 2.83696 3.76344 2.20107 4.23229 1.73223C4.70113 1.26339 5.33701 1 6.00005 1C6.66309 1 7.29898 1.26339 7.76782 1.73223C8.23666 2.20107 8.50005 2.83696 8.50005 3.5ZM13.5001 6C13.5001 6.24623 13.4516 6.49005 13.3573 6.71753C13.2631 6.94502 13.125 7.15171 12.9509 7.32582C12.7768 7.49993 12.5701 7.63805 12.3426 7.73227C12.1151 7.8265 11.8713 7.875 11.6251 7.875C11.3788 7.875 11.135 7.8265 10.9075 7.73227C10.68 7.63805 10.4733 7.49993 10.2992 7.32582C10.1251 7.15171 9.98701 6.94502 9.89278 6.71753C9.79855 6.49005 9.75005 6.24623 9.75005 6C9.75005 5.50272 9.9476 5.02581 10.2992 4.67417C10.6509 4.32254 11.1278 4.125 11.6251 4.125C12.1223 4.125 12.5992 4.32254 12.9509 4.67417C13.3025 5.02581 13.5001 5.50272 13.5001 6Z"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.5 11.75H7.5M6 10.5V13"
              stroke="#111927"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
    }

    return {
      label: item.displayName,
      value: item.key,
      icon: icon,
    };
  });
};

export const AnnouncementIcon = () => {
  return (
    <Tooltip title="Team Announcement">
      <svg
        width="61"
        height="46"
        viewBox="0 0 61 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_38100_134891)">
          <path
            d="M40.0998 18.4084L40.0011 18.4409L39.7042 18.5346C39.2307 18.6796 39.3154 18.6532 39.3154 18.6532L33.1603 20.5692L33.1607 26.1264L41.4552 28.7068C41.388 25.2032 41.3985 21.4933 41.4563 17.9865L40.0998 18.4084ZM31.627 26.0223L31.6797 26.0231L32.374 26.0225L32.3737 20.6702L29.4595 20.6703C28.7248 20.6712 28.0557 20.9729 27.5708 21.4579C27.0921 21.9382 26.7912 22.5969 26.7835 23.3219L26.784 23.3743C26.7916 24.0975 27.0916 24.7573 27.5696 25.2358C28.0494 25.7153 28.7086 26.0153 29.4313 26.0229L31.6256 26.0227L31.627 26.0223ZM32.0436 26.8039L32.043 29.5922C32.6597 29.6214 33.2261 29.3931 33.6738 29.0074C34.1417 28.605 34.4834 28.0337 34.6278 27.4042L32.7055 26.806L32.0436 26.8039ZM32.0441 30.378L32.0439 34.7448C32.0368 35.1693 31.8602 35.5552 31.581 35.8357C31.2946 36.1227 30.8984 36.3001 30.4619 36.3015L30.4325 36.3011C30.0076 36.2926 29.6221 36.1174 29.3421 35.8374C29.0551 35.5509 28.8777 35.1548 28.8763 34.7182L28.8773 26.7589C28.1574 26.6358 27.5115 26.2901 27.0157 25.7931C26.3955 25.1733 26.0075 24.3194 26.0005 23.3799L26 23.35C26.0003 22.3957 26.3894 21.531 27.0157 20.9037C27.6419 20.2764 28.5083 19.8874 29.4602 19.8876L32.7061 19.8871L41.4938 17.1524C41.5537 16.8354 41.71 16.5502 41.9294 16.3323C42.2051 16.0557 42.5841 15.8814 43.0034 15.8689L43.0825 15.8672C43.5051 15.8756 43.8887 16.052 44.1678 16.3316C44.4453 16.6078 44.6196 16.9867 44.6313 17.4055C44.6609 21.2757 44.7456 25.3991 44.6317 29.2494C44.6301 29.683 44.4529 30.078 44.1675 30.3632C43.8879 30.6423 43.5043 30.8187 43.0819 30.8282L43.0052 30.8278C42.5864 30.8169 42.206 30.641 41.9294 30.3653C41.7101 30.1463 41.5549 29.8613 41.4945 29.5435L35.3815 27.6411C35.1916 28.4089 34.7661 29.107 34.1876 29.6043C33.6025 30.1072 32.8607 30.4095 32.0442 30.3798L32.0441 30.378ZM29.6619 26.8025L29.6619 34.7149C29.6621 34.934 29.7516 35.1337 29.8969 35.278C30.0373 35.4183 30.2304 35.5085 30.4405 35.5137L30.4598 35.513C30.679 35.5129 30.8787 35.4233 31.023 35.2781C31.1633 35.1376 31.252 34.9449 31.2587 34.7345L31.2583 26.7981C30.7246 26.7955 30.1907 26.7951 29.6616 26.801L29.6619 26.8025ZM42.2503 29.2332L42.2511 29.242L42.2506 29.2429C42.2499 29.4615 42.3403 29.6618 42.4847 29.8055C42.6251 29.9458 42.8173 30.0354 43.0269 30.0416L43.0476 30.0405C43.2659 30.0399 43.4656 29.9503 43.6102 29.8065C43.753 29.6639 43.8429 29.4671 43.8456 29.2532C43.8359 25.3199 43.8722 21.3809 43.8462 17.4491C43.8464 17.2313 43.7563 17.0325 43.6111 16.8883C43.4649 16.7435 43.2664 16.6526 43.0486 16.6524C42.8286 16.652 42.6298 16.7421 42.4846 16.8868C42.3448 17.0264 42.2567 17.2159 42.2497 17.425C42.2505 17.442 42.2513 17.4591 42.2493 17.4769L42.2494 29.2353L42.2503 29.2332Z"
            fill="#6366F1"
          />
          <g clipPath="url(#clip1_38100_134891)">
            <path
              d="M23.4998 24.5827C27.4119 24.5827 30.5832 21.4114 30.5832 17.4993C30.5832 13.5873 27.4119 10.416 23.4998 10.416C19.5878 10.416 16.4165 13.5873 16.4165 17.4993C16.4165 21.4114 19.5878 24.5827 23.4998 24.5827Z"
              fill="#6366F1"
            />
            <path
              d="M23.4998 14.666V20.3327M20.6665 17.4993H26.3332M30.5832 17.4993C30.5832 21.4114 27.4119 24.5827 23.4998 24.5827C19.5878 24.5827 16.4165 21.4114 16.4165 17.4993C16.4165 13.5873 19.5878 10.416 23.4998 10.416C27.4119 10.416 30.5832 13.5873 30.5832 17.4993Z"
              stroke="white"
              strokeWidth="0.9"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <rect
          x="0.5"
          y="5.5"
          width="60"
          height="35"
          rx="11.5"
          stroke="#6366F1"
          strokeOpacity="0.6"
        />
        <defs>
          <clipPath id="clip0_38100_134891">
            <rect
              y="5"
              width="61"
              height="36"
              rx="12"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_38100_134891">
            <rect
              width="17"
              height="17"
              fill="white"
              transform="translate(15 9)"
            />
          </clipPath>
        </defs>
      </svg>
    </Tooltip>
  );
};

export const PayerInfoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="info-circle">
        <path
          id="Icon"
          d="M12 15.6V12M12 8.4H12.009M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke="#6366F1"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const PersonStarIcon = () => {
  return (
    <Tooltip title="Set as default therapist">
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon_Person star">
          <path
            id="Vector"
            d="M8.27125 5.3592C6.81539 5.3592 5.63075 4.15722 5.63075 2.67967C5.63075 1.20221 6.81533 0 8.27125 0C9.72712 0 10.9116 1.20215 10.9116 2.67967C10.9116 4.15714 9.7272 5.3592 8.27125 5.3592ZM8.27125 0.697945C7.19448 0.697945 6.3185 1.58691 6.3185 2.67967C6.3185 3.77226 7.19446 4.66126 8.27125 4.66126C9.34787 4.66126 10.2239 3.77229 10.2239 2.67967C10.2239 1.58692 9.3479 0.697945 8.27125 0.697945ZM8.27125 11.8286C5.29577 11.8286 2.54236 11.5672 2.54236 9.67047C2.54236 7.99467 5.04488 6.04668 8.27125 6.04668C11.4976 6.04668 14 7.99467 14 9.67047C14 11.5671 11.2467 11.8286 8.27125 11.8286ZM8.27125 6.74462C5.55625 6.74462 3.23011 8.35353 3.23011 9.67047C3.23011 10.9646 5.92419 11.1306 8.27125 11.1306C10.6182 11.1306 13.3123 10.9647 13.3123 9.67047C13.3123 8.35347 10.9861 6.74462 8.27125 6.74462ZM3.59203 6.3096C3.48608 6.3096 3.37963 6.2837 3.28107 6.23122L2.47462 5.80079L1.668 6.23122C1.44216 6.35186 1.17268 6.33209 0.965644 6.17976C0.758777 6.02726 0.657034 5.7737 0.70019 5.51793L0.85433 4.60631L0.201849 3.96084C0.0186663 3.77954 -0.0458097 3.51372 0.0331087 3.26698C0.112192 3.02025 0.318378 2.84372 0.57141 2.80622L1.47323 2.67331L1.87637 1.84417C1.98971 1.61141 2.2189 1.46692 2.47462 1.46692C2.73017 1.46692 2.95936 1.61141 3.07253 1.84401C3.07253 1.84401 3.07253 1.84418 3.07269 1.84418L3.47584 2.67333L4.37766 2.80623C4.63086 2.84372 4.83704 3.02026 4.91596 3.26699C4.99487 3.51373 4.9304 3.77955 4.74738 3.96068L4.09472 4.60631L4.24869 5.51777C4.29201 5.77371 4.19026 6.02725 3.98339 6.17975C3.86653 6.2658 3.72969 6.3096 3.59201 6.3096L3.59203 6.3096ZM0.711967 3.49092L1.46386 4.23454C1.54495 4.31479 1.58206 4.43032 1.56292 4.54346L1.38528 5.59345L2.31464 5.09759C2.41471 5.04408 2.5346 5.04408 2.63467 5.09759L3.56386 5.59345L3.38638 4.54346C3.36707 4.43032 3.40418 4.31479 3.48528 4.23454L4.23717 3.49092L3.19816 3.33773C3.086 3.32121 2.98929 3.24981 2.93908 3.14671L2.46828 2.17835L2.01007 3.14671C1.95987 3.2498 1.86315 3.3212 1.75099 3.33773L0.711967 3.49092Z"
            fill="black"
          />
        </g>
      </svg>
    </Tooltip>
  );
};

export const PriorityHigh = () => {
  return (
    <Tooltip title="Overdue">
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.34961 5.15V8M8.34961 10.85H8.35673M15.4746 8C15.4746 11.935 12.2846 15.125 8.34961 15.125C4.41458 15.125 1.22461 11.935 1.22461 8C1.22461 4.06497 4.41458 0.875 8.34961 0.875C12.2846 0.875 15.4746 4.06497 15.4746 8Z"
          stroke="#F04438"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Tooltip>
  );
};


export const SignOnBehalfIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14.4399 19.0473L15.9599 20.5673L18.9999 17.5273" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.1602 10.87C12.0602 10.86 11.9402 10.86 11.8302 10.87C9.45022 10.79 7.56022 8.84 7.56022 6.44C7.55022 3.99 9.54022 2 11.9902 2C14.4402 2 16.4302 3.99 16.4302 6.44C16.4302 8.84 14.5302 10.79 12.1602 10.87Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.9899 21.8097C10.1699 21.8097 8.35992 21.3497 6.97992 20.4297C4.55992 18.8097 4.55992 16.1697 6.97992 14.5597C9.72992 12.7197 14.2399 12.7197 16.9899 14.5597" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
}